// @flow

import server from 'server2';
import {Client} from './client';

import { getStatisticsHeaders } from 'app-my-dms-insurance/app/utils/get-statistics-headers';

import type { FetchPlusClientInterface, Options } from 'server2';
import type {ClientOptions} from './client/client';

export interface IClient extends FetchPlusClientInterface {
	get (urlParts: Array<string>, options?: Options): Promise<*>;
	post (urlParts: Array<string>, options?: Options): Promise<*>;
	put (urlParts: Array<string>, options?: Options): Promise<*>;
	del (urlParts: Array<string>, options?: Options): Promise<*>;
}

export interface IApi {
	any: IClient,
	my: IClient,
}

/*
	1. TODO: server2 uses alwaysJsonMiddleware

	| 'arraybuffer'
	| 'blob'
	| 'document'
	| 'json'
	| 'text'
	| 'stream';

	2. Different wrappers .responseJSON, etc.
 */

export default class Api {
	_clients: {
		my: IClient,
		any: IClient
	};

	get any (): IClient {
		return this._clients.any;
	}

	get my (): IClient {
		return this._clients.my;
	}


	constructor () {
		const params: ClientOptions = {
			onUrlNormalize: this._normalize,
		};

		this._clients = {
			any: new Client(server.any.api.withStatisticsHeaders(this._getStatisticsHeaders()), params),
			my: new Client(server.my.api.withStatisticsHeaders(this._getStatisticsHeaders()), params),
		};
	}

	_normalize (urlParts: string[]): string[] {
		return urlParts;
	}

	_getStatisticsHeaders () {
		return getStatisticsHeaders();
	}
}
